<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height"
			@show="modal_onshow" show-footer @hide="modal_onhide" destroy-on-close transfer>
			<template #default>
				<el-form ref="form" :model="form" label-width="80px" size="mini">
					<el-form-item label="供应商">
						<el-input v-model="suppliername" readonly></el-input>
					</el-form-item>
					<el-row :gutter="0" v-if="scoretype=='bonus'">
						<el-col :span="12">
							<el-form-item label="加分项">
								<el-row :gutter="0">
									<el-input v-model="form.addoption"></el-input>
								</el-row>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="分值">
								<el-row :gutter="0">
									<el-input-number v-model="form.addscore" label="" :precision="2" :min="0"></el-input-number>
								</el-row>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="0" v-if="scoretype=='deduct'">
						<el-col :span="12">
							<el-form-item label="扣分项">
								<el-row :gutter="0">
									<emun :emptyoption="false" :cascader="true" @change="supplierdeductChange"
										name="supplierdeduct" v-model="form.deductoption" />
								</el-row>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="分值">
								<el-row :gutter="0">
									<el-input-number v-model="form.deductscore" label=""
										:precision="2" :max="0"></el-input-number>
								</el-row>
							</el-form-item>
						</el-col>
					</el-row>
					<el-form-item label="变更说明">
						<el-input type="textarea" :rows="2" placeholder="" v-model="form.mark">
						</el-input>
					</el-form-item>
					<el-form-item label="辅助证明">
						<upload :formCreateInject="true" ref="supplierscoreupload" />
					</el-form-item>
				</el-form>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
				<vxe-button status="primary" content="确定" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import upload from '@_system/components/formcomponents/common/upload/index.vue'
	import emun from '@_system/components/formcomponents/common/select/emun/select.vue'
	export default {
		mixins: [modalMixins],
		props: {
			scoretype: {
				default: () => {
					return 'deduct'
				}
			},
			currentrow: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				suppliername: null,
				modal_title: '供应商打分',
				modal_width: 600,
				modal_height: 500,
				list_footerField: [{
					field: 'needamount',
					toFixed: 2
				}],
				form: {
					addoption: null,
					addscore: 0,
					deductoption: null,
					deductscore: 0,
					mark: null
				}
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			initform(){
				this.form =  {
					addoption: null,
					addscore: 0,
					deductoption: null,
					deductscore: 0,
					mark: null
				}
			},
			modal_init() {
				this.initform()
				this.suppliername = this.currentrow ? this.currentrow.name : null
			},
			submit() {
				this.loading = true
				this.form.supplierid = this.currentrow.id
				this.form.file_img = this.$refs.supplierscoreupload.value
				if(!this.form.addoption && !this.form.deductoption){
					this.$message.error('【加分项】或【减分项】不能都为空')
					return
				}
				this.$api.supplierscore.updatescore(this.form).then(()=>{
					this.loading = false
					this.$emit('success')
					this.modal_cancel()
					this.$message.success('操作成功')
				},()=>{
					this.loading = false
				})
				//this.init()
			},
			reset() {
				//this.init()
			},
			supplierdeductChange(e) {
				if (e) {
					let deducttype = e[e.length - 1]
					this.$api.emunextend_supplierdeduct.get(deducttype).then((res) => {
						if (res) {
							this.form.deductscore = res.score
						}
					})
				}
				console.log(window.systemData)
			}
		},
		components: {
			upload,
			emun
		}
	}
</script>